import * as Types from '../../../types/types.generated';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type AggregateRequirementMutationVariables = Types.Exact<{
  reqId: Types.Scalars['ID'];
}>;


export type AggregateRequirementMutation = { __typename?: 'Mutation', aggregateRequirement: boolean };

export type AggregateRequirementsMutationVariables = Types.Exact<{ [key: string]: never; }>;


export type AggregateRequirementsMutation = { __typename?: 'Mutation', aggregateRequirements: boolean };


export const AggregateRequirementDocument = gql`
    mutation AggregateRequirement($reqId: ID!) {
  aggregateRequirement(reqId: $reqId)
}
    `;
export type AggregateRequirementMutationFn = Apollo.MutationFunction<AggregateRequirementMutation, AggregateRequirementMutationVariables>;

/**
 * __useAggregateRequirementMutation__
 *
 * To run a mutation, you first call `useAggregateRequirementMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAggregateRequirementMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [aggregateRequirementMutation, { data, loading, error }] = useAggregateRequirementMutation({
 *   variables: {
 *      reqId: // value for 'reqId'
 *   },
 * });
 */
export function useAggregateRequirementMutation(baseOptions?: Apollo.MutationHookOptions<AggregateRequirementMutation, AggregateRequirementMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AggregateRequirementMutation, AggregateRequirementMutationVariables>(AggregateRequirementDocument, options);
      }
export type AggregateRequirementMutationHookResult = ReturnType<typeof useAggregateRequirementMutation>;
export type AggregateRequirementMutationResult = Apollo.MutationResult<AggregateRequirementMutation>;
export type AggregateRequirementMutationOptions = Apollo.BaseMutationOptions<AggregateRequirementMutation, AggregateRequirementMutationVariables>;
export const AggregateRequirementsDocument = gql`
    mutation AggregateRequirements {
  aggregateRequirements
}
    `;
export type AggregateRequirementsMutationFn = Apollo.MutationFunction<AggregateRequirementsMutation, AggregateRequirementsMutationVariables>;

/**
 * __useAggregateRequirementsMutation__
 *
 * To run a mutation, you first call `useAggregateRequirementsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAggregateRequirementsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [aggregateRequirementsMutation, { data, loading, error }] = useAggregateRequirementsMutation({
 *   variables: {
 *   },
 * });
 */
export function useAggregateRequirementsMutation(baseOptions?: Apollo.MutationHookOptions<AggregateRequirementsMutation, AggregateRequirementsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AggregateRequirementsMutation, AggregateRequirementsMutationVariables>(AggregateRequirementsDocument, options);
      }
export type AggregateRequirementsMutationHookResult = ReturnType<typeof useAggregateRequirementsMutation>;
export type AggregateRequirementsMutationResult = Apollo.MutationResult<AggregateRequirementsMutation>;
export type AggregateRequirementsMutationOptions = Apollo.BaseMutationOptions<AggregateRequirementsMutation, AggregateRequirementsMutationVariables>;